import {
  Badge,
  Box,
  Button,
  Code,
  Flex,
  Td,
  Text,
  Tr,
  useClipboard,
  useDisclosure,
} from "@chakra-ui/react";
import ChainInfo from "components/Chains/ChainInfo";
import DecodeValuesModal from "components/Modals/DecodeValuesModal";
import RequestId from "components/Request/RequestId";
import Timestamp from "components/Timestamp";
import { useState } from "react";
import { BiSolidUpArrowSquare } from "react-icons/bi";
import { IoCheckmarkDoneSharp, IoCopyOutline } from "react-icons/io5";
import { Link } from "react-router-dom";

const RequestRow = ({ row, lastItem }) => {
  const {
    id,
    requestId,
    numCommits,
    indexedAt,
    requestFinalizedEpoch,
    requestFirstCommittedEpoch,
    resultDestinationChainDomain,
    resultRequestingChainDomain,
    resultTarget,
    resultValues,
    status,
    epochConsensusReached,
  } = row;

  const [isCopied, setIsCopied] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { onCopy } = useClipboard(resultValues);

  const handleCopy = () => {
    onCopy();
    setIsCopied(true);
    // Reset the copied state after a delay
    setTimeout(() => setIsCopied(false), 2000);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Finalized":
        return "green";
      case "Reveal":
        return "blue";
      case "Commit":
        return "yellow";
      case "Signing":
        return "purple";
      default:
        return "gray";
    }
  };

  return (
    <>
      <Tr>
        <Td
          minWidth={{ sm: "250px" }}
          ps="0px"
          border={lastItem ? "none" : null}
          borderBottomColor="#56577A"
        >
          <Text fontSize="sm" color="#fff" fontWeight="bold">
            {requestId ? <RequestId requestId={requestId} isLink /> : "-"}
          </Text>
        </Td>
        <Td border={lastItem ? "none" : null} borderBottomColor="#56577A">
          <Badge
            fontSize="sm"
            p="3px 10px"
            borderRadius="8px"
            fontWeight="bold"
            colorScheme={status ? getStatusColor(status) : "gray"}
          >
            {status ?? "-"}
          </Badge>
        </Td>
        <Td border={lastItem ? "none" : null} borderBottomColor="#56577A">
          <ChainInfo chainId={resultRequestingChainDomain} />
        </Td>
        <Td border={lastItem ? "none" : null} borderBottomColor="#56577A">
          <ChainInfo chainId={resultDestinationChainDomain} />
        </Td>
        <Td border={lastItem ? "none" : null} borderBottomColor="#56577A">
          <Flex alignItems="center">
            {resultValues ? (
              <>
                <Box className="cursor-pointer" mr="2">
                  <BiSolidUpArrowSquare onClick={onOpen} />
                </Box>
                <Code className="code-ellipsis ml-2">{resultValues}</Code>
                <Button
                  onClick={handleCopy}
                  padding={0}
                  colorScheme="gray"
                  ml="4px"
                >
                  {isCopied ? <IoCheckmarkDoneSharp /> : <IoCopyOutline />}
                </Button>
              </>
            ) : (
              "-"
            )}
          </Flex>
        </Td>
        <Td border={lastItem ? "none" : null} borderBottomColor="#56577A">
          <Text fontSize="sm" color="#fff" fontWeight="bold">
            {requestFirstCommittedEpoch ? (
              <Link to={`/blocks/${requestFirstCommittedEpoch}`}>
                {requestFirstCommittedEpoch}
              </Link>
            ) : (
              "-"
            )}
          </Text>
        </Td>
        <Td border={lastItem ? "none" : null} borderBottomColor="#56577A">
          <Text fontSize="sm" color="#fff" fontWeight="bold">
            {requestFinalizedEpoch ? (
              <Link to={`/blocks/${requestFinalizedEpoch}`}>
                {requestFinalizedEpoch}
              </Link>
            ) : (
              "-"
            )}
          </Text>
        </Td>
        <Td border={lastItem ? "none" : null} borderBottomColor="#56577A">
          <Text fontSize="sm" color="#fff" fontWeight="bold">
            {numCommits ?? "-"}
          </Text>
        </Td>
        <Td border={lastItem ? "none" : null} borderBottomColor="#56577A">
          <Timestamp
            timestamp={indexedAt}
            fontSize="sm"
            color="#fff"
            fontWeight="bold"
          />
        </Td>
      </Tr>
      {resultValues && (
        <DecodeValuesModal
          isOpen={isOpen}
          onClose={onClose}
          resultValues={resultValues}
          types={["bytes", "bytes"]}
          keys={["Message", "Result"]}
        />
      )}
    </>
  );
};

export default RequestRow;
